var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disable"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00016 1.33337C4.32683 1.33337 1.3335 4.32671 1.3335 8.00004C1.3335 11.6734 4.32683 14.6667 8.00016 14.6667C11.6735 14.6667 14.6668 11.6734 14.6668 8.00004C14.6668 4.32671 11.6735 1.33337 8.00016 1.33337ZM10.2402 9.53337C10.4335 9.72671 10.4335 10.0467 10.2402 10.24C10.1402 10.34 10.0135 10.3867 9.88683 10.3867C9.76016 10.3867 9.6335 10.34 9.5335 10.24L8.00016 8.70671L6.46683 10.24C6.36683 10.34 6.24016 10.3867 6.1135 10.3867C5.98683 10.3867 5.86016 10.34 5.76016 10.24C5.56683 10.0467 5.56683 9.72671 5.76016 9.53337L7.2935 8.00004L5.76016 6.46671C5.56683 6.27337 5.56683 5.95337 5.76016 5.76004C5.9535 5.56671 6.2735 5.56671 6.46683 5.76004L8.00016 7.29337L9.5335 5.76004C9.72683 5.56671 10.0468 5.56671 10.2402 5.76004C10.4335 5.95337 10.4335 6.27337 10.2402 6.46671L8.70683 8.00004L10.2402 9.53337Z",
    fill: "#F5315D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.0972baaab9f958a5a05f3a6032619d88.svg";
export { ForwardRef as ReactComponent };